import { DateTime } from 'luxon';
import type { ColumnsType } from 'antd/es/table';
import type { DetectionReport } from '../api/go';

export interface ProcessDataTableRow {
  key: number;
  log_id: number;
  date: string;
  category_names: string[];
  pname: string;
  path: string;
  pid: number;
  titles: string[];
  access_rights: string[];
  access_rights_raw: string;
}

export const processDataColumns: ColumnsType<ProcessDataTableRow> = [
  {
    title: '时间',
    dataIndex: 'date',
    key: 'date',
    width: 180,
    render: (value: string) => DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm:ss'),
  },
  {
    title: '命中分类',
    dataIndex: 'category_names',
    key: 'category_names',
    width: 220,
    render: (value: string[]) => value.join(' / '),
  },
  {
    title: '进程名',
    dataIndex: 'pname',
    key: 'pname',
    width: 180,
  },
  {
    title: '路径',
    dataIndex: 'path',
    key: 'path',
    width: 360,
    render: (value: string) => <div style={{ wordBreak: 'break-all', textAlign: 'left' }}>{value || '-'}</div>,
  },
  {
    title: 'PID',
    dataIndex: 'pid',
    key: 'pid',
    width: 100,
  },
  {
    title: '窗口标题',
    dataIndex: 'titles',
    key: 'titles',
    width: 320,
    render: (value: string[]) => (
      <div style={{ wordBreak: 'break-word', textAlign: 'left' }}>{value.length > 0 ? JSON.stringify(value) : '-'}</div>
    ),
  },
  {
    title: '访问权限',
    dataIndex: 'access_rights',
    key: 'access_rights',
    width: 280,
    render: (value: string[], record) => (
      <div style={{ wordBreak: 'break-word', textAlign: 'left' }}>
        {value.length > 0 ? JSON.stringify(value) : record.access_rights_raw || '-'}
      </div>
    ),
  },
];

export function flattenProcessDataReport(report: DetectionReport): ProcessDataTableRow[] {
  const rowMap = new Map<number, ProcessDataTableRow>();

  for (const category of report.categories) {
    for (const log of category.matched_logs) {
      const existing = rowMap.get(log.log_id);
      if (existing) {
        if (!existing.category_names.includes(category.name)) {
          existing.category_names.push(category.name);
        }
        continue;
      }

      rowMap.set(log.log_id, {
        key: log.log_id,
        log_id: log.log_id,
        date: log.date,
        category_names: [category.name],
        pname: log.pname,
        path: log.path,
        pid: log.pid,
        titles: log.titles || [],
        access_rights: log.access_rights || [],
        access_rights_raw: log.access_rights_raw,
      });
    }
  }

  return Array.from(rowMap.values()).sort((left, right) => {
    const dateDiff = DateTime.fromISO(right.date).toMillis() - DateTime.fromISO(left.date).toMillis();
    if (dateDiff !== 0) {
      return dateDiff;
    }
    return right.log_id - left.log_id;
  });
}
